import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MenuController, ModalController } from '@ionic/angular';
import { Faq, FaqCategory, SettingsService } from 'src/app/shared-lib/core/settings';
import { ImageModalComponent } from '../image-modal/image-modal.component';

@Component({
  selector: 'app-faq-sidebar',
  templateUrl: './faq-sidebar.component.html',
  styleUrls: ['./faq-sidebar.component.scss'],
  standalone: false
})
export class FaqSidebarComponent implements OnInit, AfterViewInit, OnDestroy {
  faqs: Faq[] = [];
  accordionOpen: { [id: string]: boolean; } = {};

  categories = [
    { key: FaqCategory.CONFIGURATION, icon: 'faqs-printer.svg', label: 'Dudas sobre configuraciones, impresión y acabados.', id: 'configuracion' },
    { key: FaqCategory.FILES, icon: 'faqs-book.svg', label: 'Dudas sobre tus archivos y cómo debes enviarlos.', id: 'archivos' },
    { key: FaqCategory.SHIPMENTS, icon: 'faqs-envio.svg', label: 'Dudas sobre envíos o el seguimiento de tu pedido.', id: 'envios' },
    { key: FaqCategory.MANAGEMENT, icon: 'faqs-sidebar.svg', label: 'Dudas sobre la gestión de tu pedido, incidencias, cancelaciones, errores, etc.', id: 'gestion' },
    { key: FaqCategory.BONUS, icon: 'faqs-euro.svg', label: 'Dudas sobre bonos, saldo monedero y descuentos.', id: 'bonos' }
  ];

  @ViewChild('faqContent', { static: false }) faqContent!: ElementRef;
  private observer: MutationObserver | undefined;

  constructor(
    private settingsService: SettingsService,
    private menuCtrl: MenuController,
    private modalController: ModalController
  ) { }

  ngOnInit() {
    this.settingsService.getFaqs$().subscribe(faqs => {
      this.faqs = faqs;
      setTimeout(() => this.agregarClickImagenes(), 500);
    });

  }

  ngAfterViewInit() {
    this.agregarClickImagenes();
    this.observer = new MutationObserver(() => {
      this.agregarClickImagenes();
    });
    if (this.faqContent) {
      this.observer.observe(this.faqContent.nativeElement, { childList: true, subtree: true });
    }
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  agregarClickImagenes() {
    let imgs: NodeListOf<HTMLImageElement>;
    if (this.faqContent) {
      imgs = this.faqContent.nativeElement.querySelectorAll('img');
    } else {
      imgs = document.querySelectorAll('.faq-content img');
    }
    imgs.forEach((img: HTMLImageElement) => {
      if (
        !img.classList.contains('faq-category-icon') &&
        !img.classList.contains('faq-section-header-icon')
      ) {
        img.style.cursor = 'pointer';
        img.onclick = (event) => {
          event.stopPropagation();
          this.mostrarImagenGrande(img.src);
        };
      }
    });
  }

  async mostrarImagenGrande(src: string) {
    const modal = await this.modalController.create({
      component: ImageModalComponent,
      componentProps: {
        imgSrc: src
      },
      cssClass: 'image-modal',
      backdropDismiss: true,
      showBackdrop: true,
      animated: true,
    });

    return modal.present();
  }

  closeMenu() {
    this.menuCtrl.close('faqs-menu');
  }

  scrollToSection(id: string) {
    const el = document.getElementById(id);
    const container = document.querySelector('.faq-content');
    if (el && container) {
      const elTop = el.offsetTop;
      container.scrollTo({ top: elTop - 80, behavior: 'smooth' });
    }
  }

  toggleAccordion(id: string) {
    this.accordionOpen[id] = !this.accordionOpen[id];
    setTimeout(() => this.agregarClickImagenes(), 100);
  }

  getFaqsByCategory(category: string) {
    return this.faqs.filter(f => (f.category || '').toLowerCase() === category.toLowerCase());
  }
}
